module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-cantainer"
  }, [_c('div', {
    staticClass: "product-main"
  }, [_c('div', {
    staticClass: "product-img"
  }, [_c('div', {
    staticClass: "prod-img-top"
  }, [_c('div', {
    staticClass: "show-img"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('el-image', {
    key: _vm.nowIndex,
    staticClass: "goodImg",
    staticStyle: {
      "height": "90%"
    },
    attrs: {
      "src": _vm.nowImg,
      "preview-src-list": _vm.imgList
    }
  })], 1)], 1), _vm._v(" "), (_vm.imgList.length > 1) ? _c('div', {
    staticClass: "img-list"
  }, _vm._l((_vm.imgList), function(item, index) {
    return _c('img', {
      key: index,
      style: (_vm.nowIndex == index ? 'border:1px solid #1077FF' : ''),
      attrs: {
        "src": item
      },
      on: {
        "click": function($event) {
          return _vm.switchImg(index)
        },
        "mouseover": function($event) {
          return _vm.switchImg(index)
        }
      }
    })
  }), 0) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "product-details"
  }, [_c('div', {
    staticClass: "prod-title-box"
  }, [_c('p', {
    staticClass: "prod-title"
  }, [_vm._v(_vm._s(_vm.msg.itemTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "prod-info"
  }, [_c('div', {
    staticClass: "prod-info-price"
  }, [_c('span', [_vm._v("￥")]), _vm._v(_vm._s(_vm.msg.price) + "\n        ")]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "margin-top": "10px",
      "line-height": "25px",
      "font-size": "14px",
      "padding-bottom": "10px",
      "border-bottom": "1px solid #ccc"
    }
  }, [_c('li', [_vm._v("\n            预售，7天内发货 | 快递:免运费\n          ")]), _vm._v(" "), _c('li', [_vm._v("退货宝 | 7天内无理由退货 | 极速退款")]), _vm._v(" "), _c('li', [_vm._v("材料供应商：" + _vm._s(_vm.msg.supplier || ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_vm._v("\n          规格\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "prod-info-detail"
  }, _vm._l((_vm.product.spu), function(val, i) {
    return (val != '') ? _c('div', {
      staticClass: "model-title",
      style: (_vm.labelNum == i ? 'color: #FF5300;border:1px solid #FF5300;' : ''),
      on: {
        "click": function($event) {
          return _vm.clickGoods(i, val)
        }
      }
    }, [_vm._v("\n           " + _vm._s(val) + "\n          ")]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "statistics"
  }, [_c('span', [_vm._v("数量选择")]), _vm._v(" "), _c('el-input-number', {
    staticStyle: {
      "margin-left": "50px",
      "width": "130px"
    },
    attrs: {
      "min": 1,
      "max": 999
    },
    model: {
      value: (_vm.productNum),
      callback: function($$v) {
        _vm.productNum = $$v
      },
      expression: "productNum"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#8d9ba8"
    }
  }, [_vm._v("\n        有货\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "prod-total"
  }, [_c('span', [_vm._v(" 合计  ￥"), _c('span', {
    staticClass: "total-txt"
  }, [_vm._v(_vm._s(_vm.msg.price * _vm.productNum))]), _vm._v(" 元")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px white solid",
      "margin-top": "20px",
      "width": "100%",
      "height": "15%"
    }
  }, [_c('el-button', {
    staticClass: "myBtn",
    on: {
      "click": _vm.openDialog
    }
  }, [_vm._v("立即购买")])], 1)])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "order-dialog",
    attrs: {
      "title": "订单详情",
      "visible": _vm.dialogFlag,
      "width": "800px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFlag = $event
      }
    }
  }, [_c('div', {
    staticClass: "order-content"
  }, [_c('div', {
    staticClass: "order-summary"
  }, [_c('div', {
    staticClass: "summary-title"
  }, [_vm._v(_vm._s(_vm.msg.itemTitle))]), _vm._v(" "), _c('div', {
    staticClass: "summary-price"
  }, [_c('span', {
    staticClass: "price-symbol"
  }, [_vm._v("¥")]), _vm._v(" "), _c('span', {
    staticClass: "price-number"
  }, [_vm._v(_vm._s(_vm.actualPayment))])])]), _vm._v(" "), _c('div', {
    staticClass: "fee-details"
  }, [_c('div', {
    staticClass: "fee-item"
  }, [_c('span', {
    staticClass: "fee-label"
  }, [_vm._v("订单金额")]), _vm._v(" "), _c('span', {
    staticClass: "fee-value"
  }, [_vm._v("¥" + _vm._s((_vm.msg.price * _vm.productNum).toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "fee-item"
  }, [_c('span', {
    staticClass: "fee-label"
  }, [_vm._v("数量")]), _vm._v(" "), _c('span', {
    staticClass: "fee-value"
  }, [_vm._v(_vm._s(_vm.productNum))])]), _vm._v(" "), _c('div', {
    staticClass: "fee-item"
  }, [_c('span', {
    staticClass: "fee-label"
  }, [_vm._v("当前积分")]), _vm._v(" "), _c('span', {
    staticClass: "fee-value"
  }, [_vm._v(_vm._s(_vm.user.balance))])]), _vm._v(" "), _c('div', {
    staticClass: "fee-item"
  }, [_c('span', {
    staticClass: "fee-label"
  }, [_vm._v("实付金额")]), _vm._v(" "), _c('span', {
    staticClass: "fee-value final"
  }, [_vm._v("¥" + _vm._s(_vm.actualPayment))])])]), _vm._v(" "), _c('div', {
    staticClass: "remark-box"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("订单备注：")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "请输入备注信息（如：颜色、尺码特殊要求等）",
      "maxlength": "200",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.msg.remark),
      callback: function($$v) {
        _vm.$set(_vm.msg, "remark", $$v)
      },
      expression: "msg.remark"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFlag = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("确认订单")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c1a1caa","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Mall/productDetails.vue
// module id = 669
// module chunks = 0